<template>
	<div class="sidebar-wrapper">
		<transition name="fade">
			<keep-alive include="StatusMeter">
				<router-view name="sidebar" />
			</keep-alive>
		</transition>
	</div>
</template>

<script>

export default {
	name: 'Sidebar',
	props: {
	},
	methods: {
	},
};
</script>

<style lang="scss" scoped>
	.sidebar-wrapper {
		height: 100%;
		width: $sidebar-mobile-width;
		background: $background-color-dark;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		flex-shrink: 0;
		user-select: none;

		@include tablet { width: $sidebar-width; }
		@include desktop { width: $sidebar-width; }
	}
</style>



// WEBPACK FOOTER //
// src/components/views/game/Sidebar.vue